// src/components/common/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();
  
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-columns-grid">
          <div className="footer-brand-column">
            <Link to="/" className="footer-brand-lockup" aria-label={t('footer.brand')}>
              <img src="/massal_ai_logo.svg" alt="" className="footer-logo-image" />
              <span>{t('footer.brand')}</span>
            </Link>
            <p>{t('footer.tagline')}</p>
            <a
              href="https://instagram.com/massal.ai"
              className="footer-social-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t('footer.instagram')}
              title={t('footer.instagram')}
            >
              <FaInstagram />
            </a>
          </div>
          
          <div>
            <h3>{t('footer.products')}</h3>
            <ul>
              <li>
                <Link to="/create-story" className="footer-link">{t('footer.books')}</Link>
              </li>
              <li>
                <Link to="/features#how-it-works" className="footer-link">{t('navigation.howItWorks')}</Link>
              </li>
              <li>
                <Link to="/examples" className="footer-link">{t('navigation.examples')}</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3>{t('footer.corporate')}</h3>
            <ul>
              <li>
                <Link to="/contact" className="footer-link">{t('footer.forInstitutions')}</Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">{t('navigation.contact')}</Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3>{t('footer.legal')}</h3>
            <ul>
              <li>
                <Link to="/privacy" className="footer-link">{t('footer.privacyPolicy')}</Link>
              </li>
              <li>
                <Link to="/terms" className="footer-link">{t('footer.termsOfService')}</Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom-section"> 
          <p>
            <span>© {currentYear} {t('footer.brand')}. {t('footer.rights')}</span>
            <span className="footer-bottom-separator" aria-hidden="true">|</span>
            <span className="privacy-statement">{t('footer.privacyStatement')}</span>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
